import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import get from "lodash/get";
import set from "lodash/set";
import { sortTriangle } from "@assets/images";
import { onFormChange } from "@features/schema-management/interfaces/schemaManagementInterface";

const CustomTitleFieldTemplate = ({ id, title, uiSchema }) => {
  const dispatch = useDispatch();
  const sypiNewView = useSelector((state) => state.sypiNewView);
  const schemaAllView = useSelector((state) => state.schemaAllView);
  const { fieldVisibility } = sypiNewView ? sypiNewView : schemaAllView;

  const REMOVABLE = "removable";

  const activeKey = `${id?.split("root.")[1]?.split("__title")[0]}.active`;

  const allowDisabling = uiSchema["ui:classname"] === REMOVABLE;
  const [disabled, setDisabled] = useState(
    allowDisabling && get(schemaAllView?.schemaManagementConfig, !activeKey)
  );
  const [visible, setVisibility] = useState(true);

  useEffect(() => {
    const path = sypiNewView
      ? id.split("_").slice(1).join(".").split("..")[0]
      : id.replace(/^root./, "").replace(/__.*$/, "");
    const pulledDiff =
      path === "_title" && schemaAllView
        ? { defaultDisplay: true }
        : get(fieldVisibility, path);
    // Default to expanded when visibility hasn't been computed yet to avoid a race-condition collapse.
    setVisibility(pulledDiff ? pulledDiff.defaultDisplay : true);
  }, [fieldVisibility]);

  const handleDisablingAction = (action) => {
    setDisabled(action);
    setVisibility(!action);
    const updatedConfig = set(
      schemaAllView?.schemaManagementConfig,
      activeKey,
      !action
    );
    onFormChange(updatedConfig);
  };

  return (
    <legend className={`flex w-full ${!visible ? "hide-sibling" : ""}`} id={id}>
      {title}{" "}
      {disabled ? (
        <div
          className={`font-normal ml-4 text-color-teal cursor-pointer hover:opacity-50`}
          onClick={() => handleDisablingAction(false)}
        >
          Reset
        </div>
      ) : (
        <img
          src={!visible ? sortTriangle.up : sortTriangle.down}
          className="h-max my-auto mx-2 cursor-pointer"
          onClick={() => setVisibility(!visible)}
        />
      )}
      {allowDisabling && !disabled && (
        <div
          className={`font-normal ml-4 text-color-teal cursor-pointer hover:opacity-50`}
          onClick={() => handleDisablingAction(true)}
        >
          Disable
        </div>
      )}
    </legend>
  );
};

export default CustomTitleFieldTemplate;
